import styled from 'styled-components';

export const UserStatusesModalStyled = styled.div`
    background: var(--color-background-primary);
    padding-top: 32px;
    border-radius: 0 0 24px 24px;
    position: relative;
`;
